/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type Tier = typeof Tier[keyof typeof Tier];


export const Tier = {
  tier_1: 'tier_1',
  tier_2: 'tier_2',
  tier_3: 'tier_3',
} as const;
